"use client";

import { RuntimeErrorFallback } from "@/components/flowbite/error-page/runtime-error-fallback";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html className="h-screen">
      <body className="h-screen bg-background-primary antialiased">
        <RuntimeErrorFallback onRetry={reset} />
      </body>
    </html>
  );
}
